import { SignatureRequestStatus } from 'constants/loanApplication';

export const getIsESigned = ({ isSignable, status }) => {
  if (!isSignable) {
    return 'N/A';
  }

  const isESigned = [
    SignatureRequestStatus.COMPLETED,
    SignatureRequestStatus.SIGNED_WITHOUT_DOCUMENT,
  ].includes(status);

  return isESigned ? 'Yes' : 'No';
};
